import React from 'react';
import { ShieldCheckIcon, XMarkIcon } from '@heroicons/react/24/outline';

export default function AlertBanner({ isNewUser, onDismiss, dismissed }) {
  if (!isNewUser || dismissed) return null;

  return (
    <div className="rounded-xl border border-primary-200 dark:border-primary-800 bg-primary-50/80 dark:bg-primary-900/30 p-4 flex items-start gap-3">
      <div className="shrink-0 rounded-lg bg-primary-100 dark:bg-primary-800/50 p-2">
        <ShieldCheckIcon className="h-5 w-5 text-primary-600 dark:text-primary-400" />
      </div>
      <div className="min-w-0 flex-1">
        <h3 className="text-sm font-semibold text-primary-900 dark:text-primary-100">Welcome to Willowvale Credit Union</h3>
        <p className="mt-0.5 text-sm text-primary-700 dark:text-primary-300">
          Complete your profile and set up security options for the best experience.
        </p>
      </div>
      <button
        type="button"
        onClick={onDismiss}
        className="shrink-0 p-1 rounded-lg text-primary-600 dark:text-primary-400 hover:bg-primary-100 dark:hover:bg-primary-800/50 transition-colors"
        aria-label="Dismiss"
      >
        <XMarkIcon className="h-5 w-5" />
      </button>
    </div>
  );
}
